import { Injectable } from '@angular/core';

@Injectable()
export class ContentTemplateBuilder {

    public prepareTemplate (componentNameString: any , entity: any) {
        let template = `<${componentNameString} [entity]="entity"></${componentNameString}>`;
        return template;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/content-switcher/content-template-builder.ts